import { NgModule } from '@angular/core';
import { ComponentsComponent } from './components.component';



@NgModule({
  declarations: [
    ComponentsComponent
  ],
  imports: [
  ],
  exports: [
    ComponentsComponent
  ]
})
export class ComponentsModule { }
